<div class="layout-menu-container" [class.layout-menu-rail]="rail">
  <div class="layout-sidebar-header">
    <a routerLink="/" class="layout-sidebar-brand" [attr.aria-label]="'layout.logoAlt' | translate">
      <img src="assets/images/Logo Kafa'at.png" alt="" />
    </a>
    <!-- Revealed while the pointer is over the sidebar (or a tool has keyboard focus). -->
    <div class="layout-menu-tools" *ngIf="!rail && nodes.length">
      <button type="button" class="layout-menu-tool" (click)="expandAll()" aria-keyshortcuts="Control+I Meta+I"
        [attr.aria-label]="'layout.sidebar.expandAll' | translate"
        [pTooltip]="('layout.sidebar.expandAll' | translate) + ' (' + expandCollapseShortcut + ')'" tooltipPosition="bottom" [showDelay]="400">
        <i class="pi pi-angle-double-down" aria-hidden="true"></i>
      </button>
      <button type="button" class="layout-menu-tool" (click)="collapseAll()" aria-keyshortcuts="Control+I Meta+I"
        [attr.aria-label]="'layout.sidebar.collapseAll' | translate"
        [pTooltip]="('layout.sidebar.collapseAll' | translate) + ' (' + expandCollapseShortcut + ')'" tooltipPosition="bottom" [showDelay]="400">
        <i class="pi pi-angle-double-up" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <ng-container *ngIf="!rail; else railTemplate">
    <nav class="menu-scroll" appScrollFade [attr.aria-label]="'layout.sidebar.navigation' | translate">
      <ul class="layout-menu">
        <li *ngFor="let node of nodes; trackBy: trackByKey" app-menuitem [node]="node"></li>
      </ul>
    </nav>

    <div class="layout-menu-footer">
      <span class="layout-menu-copyright">{{ 'layout.footer.copyright' | translate }}</span>
    </div>
  </ng-container>

  <ng-template #railTemplate>
    <nav class="menu-scroll" appScrollFade [attr.aria-label]="'layout.sidebar.navigation' | translate">
      <ul class="layout-rail">
        <li *ngFor="let section of nodes; trackBy: trackByKey">
          <a *ngIf="singlePage(section) as page; else sectionButton" class="layout-rail-item" [routerLink]="page.routerLink"
            [class.active-trail]="isInActiveTrail(section)" [attr.aria-label]="page.label | translate"
            (mouseenter)="openFlyout(section, $event.currentTarget)" (mouseleave)="scheduleFlyoutClose()"
            (focus)="openFlyout(section, $event.currentTarget)" (blur)="scheduleFlyoutClose()">
            <i [ngClass]="section.icon || page.icon" aria-hidden="true"></i>
          </a>
          <ng-template #sectionButton>
            <button type="button" class="layout-rail-item" [class.active-trail]="isInActiveTrail(section)"
              [class.layout-rail-item-open]="flyout?.node === section" [attr.aria-label]="section.label | translate"
              aria-haspopup="true" [attr.aria-expanded]="flyout?.node === section"
              (click)="toggleFlyout(section, $event)"
              (mouseenter)="openFlyout(section, $event.currentTarget)" (mouseleave)="scheduleFlyoutClose()">
              <i [ngClass]="section.icon || 'pi pi-fw pi-folder'" aria-hidden="true"></i>
            </button>
          </ng-template>
        </li>
      </ul>
    </nav>

    <div class="layout-menu-footer">
      <span class="layout-menu-copyright" tabindex="0" [attr.aria-label]="'layout.footer.copyright' | translate"
        (mouseenter)="showCopyrightTip($event.currentTarget)" (focus)="showCopyrightTip($event.currentTarget)"
        (mouseleave)="copyrightTip = null" (blur)="copyrightTip = null">{{ copyrightMark('layout.footer.copyright' | translate) }}</span>
    </div>

    <!-- Above the sign and growing towards the page, so it is never cut by the window or the rail. -->
    <div *ngIf="copyrightTip" class="layout-rail-tooltip" role="tooltip" aria-hidden="true"
      [style.inset-inline-start.px]="copyrightTip.start" [style.bottom.px]="copyrightTip.bottom">
      {{ 'layout.footer.copyright' | translate }}
    </div>

    <div #flyoutPanel *ngIf="flyout" class="layout-rail-flyout" role="group" [attr.aria-label]="flyout.node.label | translate"
      [style.top.px]="flyout.top" [style.inset-inline-start.px]="flyout.start" [style.max-height.px]="flyout.maxHeight"
      (mouseenter)="cancelFlyoutClose()" (mouseleave)="scheduleFlyoutClose()">
      <div class="layout-rail-flyout-title">{{ flyout.node.label | translate }}</div>
      <ul *ngIf="!singlePage(flyout.node)" class="layout-menu">
        <li *ngFor="let child of flyout.node.children; trackBy: trackByKey" app-menuitem [node]="child"></li>
      </ul>
    </div>
  </ng-template>
</div>
